import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'active-offers-campaigns-broker-performance',
  storeModule.createStoreModule('active-offers-campaigns-broker-performance')
)
